import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import {
  Button,
  FormControlLabel,
  Grid,
  Paper,
  Tab,
  Tabs,
  Switch,
  Typography,
} from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import { getAbbonamenti } from '../../../utils/api/abbonamenti_api';
import { getGruppo } from '../../../utils/api/gruppi_api.js';
import {
  getEsercizioCommerciale,
  updateEsercizioCommerciale,
  sendEmailToConfirmRegistration,
  getFunzionalitaApp,
  updateFunzionalitaApp,
  updateAllControlsCompliantStatus,
  getAllControlsCompliantStatus,
} from '../../../utils/api/esercizi_commerciali_api';
import { getRolloutStatusBatch } from '../../../utils/api/rollout_status_api';
import validator from 'validator';
import SpinnerComponent from '../../../components/SpinnerComponent';
import StoricoAbbonamentiEsercizio from './StoricoAbbonamentiEsercizio';
import IndietroButton from '../../../components/IndietroButton';
import GiorniChiusuraEsercizio from './GiorniChiusuraEsercizio';
import FormPagamento from './FormPagamento.js';
import TwoActionsAlertDialog from '../../../components/TwoActionsAlertDialog.js';
import ChipSection from './ChipSection.jsx';
import FormDettagli from './FormDettagli.jsx';
import GestioneOperativa from './GestioneOperativa.jsx';
import DocumentiSection from './documents/DocumentiSection.jsx';
import AssegnazioniIotSection from './iot/AssegnazioniIotSection.jsx';
import ContattiNotificheSection from './iot/ContattiNotificheSection.jsx';
import InterruttoreGateIotSection from './iot/InterruttoreGateIotSection.jsx';
import CustomSnackbar from '../../../components/CustomSnackbar.js';
import UnsavedChangesNavigationGuard from '../../../components/UnsavedChangesNavigationGuard.jsx';
import { UNSAVED_CHANGES_LEAVE_MESSAGE } from '../../../utils/messages';
import { reportApiError } from '../../../utils/reportApiError';

const styles = (theme) => ({
  mainContainer: {
    textAlign: 'center',
    color: 'black',
  },
  title: {
    margin: '26px 0',
  },
  tabPaper: {
    boxShadow: theme.shadows[6],
    margin: '0 4px',
  },
  tabsRoot: {
    borderBottom: `2px solid ${theme.palette.divider}`,
  },
  tabsIndicator: {
    backgroundColor: theme.palette.primary.main,
  },
  tabRoot: {
    fontWeight: 400,
    // fontSize: "1rem",
  },
  tabSelected: {
    fontWeight: 600,
    color: theme.palette.primary.main,
  },
  invioMailButton: {
    color: theme.palette.text.main,
    margin: '10px',
    backgroundColor: theme.palette.primary.main,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
    },
  },
  sectionContainer: {
    margin: '10px 0',
    padding: '40px',
    textAlign: 'left',
  },
  sectionTitle: {
    marginBottom: theme.spacing(2),
  },
  switchContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
});

class DettaglioEsercizioCommerciale extends Component {
  constructor(props) {
    super(props);
    this._isMounted = false; // Flag per controllare se il componente è montato
    this.state = {
      tabValue: 0,
      tabLoaded: [false, false, false, false, false], // [Tab0, Tab1, Tab2, Tab3, Tab4]
      // Bumped by every writer of the iot review queue that lives in this screen:
      // a successful publication (tab 1) and every review — archive or reassign —
      // done from the «Assegnazioni IoT» tab (tab 3). It has to live here and not
      // inside one of the two tabs because both stay mounted (`hidden`, not
      // conditional rendering), so switching tabs re-fires nothing and the banner
      // would keep the pre-review count until a full page reload.
      codaRicaricaToken: 0,
      record: {
        esercizio: {
          id: null,
          consulenteId: null,
          nome: null,
          ragioneSociale: null,
          partitaIva: null,
          codiceAteco: null,
          telefono: null,
          nomeGestore: null,
          cognomeGestore: null,
          emailGestore: null,
          telefonoGestore: null,
          indirizzoSede: null,
          numeroSede: null,
          codiceSdi: null,
          pec: null,
          cittaSede: null,
          provinciaSede: null,
          gruppoId: null,
          gestioneOperativaSeparata: false,
          gestitoDaPayments: false,
        },
        storicoPricingDTO: {
          unitPrice: null,
          imponibile: null,
          moltiplicatore: null,
          anniValidita: null,
          iva: null,
          totalAmount: null,
          modalita: null,
          esercizioCommercialeId: null,
          consulenteId: null,
          dataAggiornamento: null,
        },
        aggiornamentoGestioneOperativaDTO: {
          id: '',
        },
        giorniChiusura: [],
      },

      abbonamenti: [],
      tipologiaPagamento: null,
      costoUnitario: null,
      originalRecord: null,
      validationErrors: {
        nome: '',
        ragioneSociale: '',
        emailGestore: '',
      },
      funzionalitaApp: {},
      loading: false,
      notfoundRecord: false,
      saveButtonEnabled: false,
      twoActionsAlertVisible: false,
      edit: false,
      allControlsCompliantStatus: false,
      gestioneOperativaOpen: false, // Nuovo stato per gestire l'apertura della gestione operativa
      gestioneOperativaHasPendingChanges: false,

      saveCheckboxSuccess: false,
      snackbar: {
        open: false,
        message: '',
        severity: null,
      },
    };
  }

  componentDidMount() {
    this._isMounted = true;

    const tabValueFromNavigation = this.props.location?.state?.forceTab ?? null;

    if (tabValueFromNavigation !== null) {
      const updatedTabLoaded = [...this.state.tabLoaded];
      updatedTabLoaded[tabValueFromNavigation] = true;

      this.setState(
        {
          tabValue: tabValueFromNavigation,
          tabLoaded: updatedTabLoaded,
        },
        () => {
          this.props.history.replace({
            ...this.props.location,
            state: {},
          });
        },
      );
    }
    this.fetchRecord(this.props.esercizioId);
    this.fetchControlStatus(this.props.esercizioId);
    // Dopo aver caricato il record, chiama la nuova API
    getRolloutStatusBatch(
      [Number(this.props.esercizioId)],
      'GESTIONE_OPERATIVA',
    )
      .then((res) => {
        const isOpen = res.list[0]?.open;
        this.setState({ gestioneOperativaOpen: isOpen });
      })
      .catch((error) => {
        console.error(error);
        // Mostra messaggio d’errore all’utente
      });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleTabChange = (_event, newValue) => {
    this.setState((prevState) => {
      const tabLoaded = [...prevState.tabLoaded];
      if (!tabLoaded[newValue]) {
        tabLoaded[newValue] = true;
      }
      return { tabValue: newValue, tabLoaded };
    });
  };

  /**
   * Makes the iot review-queue banner re-read its count. Called by whichever of
   * the two mounted tabs just changed the queue: the publication, and each review
   * answered from the «Assegnazioni IoT» tab.
   */
  ricaricaConteggioCodaRevisione = () => {
    this.setState((prevState) => ({
      codaRicaricaToken: prevState.codaRicaricaToken + 1,
    }));
  };

  handleGestioneOperativaPendingChanges = (hasPendingChanges) => {
    this.setState({ gestioneOperativaHasPendingChanges: hasPendingChanges });
  };

  fetchControlStatus = (esercizioId) => {
    getAllControlsCompliantStatus(esercizioId)
      .then((response) =>
        this.setState({ allControlsCompliantStatus: response.value }),
      )
      .catch((error) => {
        this.setState({ notfoundRecord: true });
        reportApiError(error);
      });
  };

  fetchRecord = (esercizioId) => {
    this.setState({
      loading: true,
    });
    getEsercizioCommerciale(esercizioId)
      .then((result) => {
        if (this._isMounted) {
          if (result.storicoPricingDTO) {
            result.storicoPricingDTO.consulenteId =
              this.props.consulenteId !== null ? this.props.consulenteId : null;
          }
          this.setState({
            notfoundRecord: false,
            loading: false,
            record: {
              ...result,
            },
            originalRecord: JSON.parse(JSON.stringify(result)),
          });
          this.fetchAbbonamenti();
          this.fetchFunzionalitaApp();
        }
      })
      .catch((error) => {
        if (this._isMounted) {
          this.setState({ loading: false, notfoundRecord: true });
          reportApiError(error);
        }
      });
  };

  fetchAbbonamenti = () => {
    getAbbonamenti(null, null, this.state.record.esercizio.id, 0, 1000, 'id')
      .then((result) => {
        this.setState(
          {
            abbonamenti: result,
            edit: false,
          },
          () => {
            this.fetchGruppo(this.state.record.esercizio.gruppoId);
          },
        );
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  fetchGruppo = (gruppoId) => {
    getGruppo(gruppoId)
      .then((response) => {
        this.setState({
          loading: false,
          tipologiaPagamento: response.tipologiaPagamento,
          costoUnitario: response.costoUnitario,
        });
      })
      .catch((error) => {
        this.setState({ loading: false });
        reportApiError(error);
      });
  };

  // Read for every role: the IoT tabs follow these modules, and the server
  // admits the consulente of the esercizio as it does the superconsulente of
  // its gruppo. Only editing the modules is kept from the consulente, by the
  // guard on ChipSection.
  fetchFunzionalitaApp = () => {
    getFunzionalitaApp(this.props.esercizioId)
      .then((response) => {
        this.setState({
          funzionalitaApp: response,
        });
      })
      .catch((error) => {
        reportApiError(error);
      });
  };

  validateForm = () => {
    let data = this.state.record;
    Object.keys(data.esercizio).forEach((key) => {
      this.validateField(key, data.esercizio[key]);
    });
    //Return false if there are validation errors:
    let valid = true;
    let validationErrors = this.state.validationErrors;
    Object.values(validationErrors).forEach((val) => {
      val.length > 0 && (valid = false);
    });
    return valid;
  };

  validateField = (key, value) => {
    let validationErrors = this.state.validationErrors;
    switch (key) {
      case 'nome':
        if (value === null || value.length === 0) {
          validationErrors.nome = 'Inserire nome';
        } else {
          validationErrors.nome = '';
        }
        break;
      case 'ragioneSociale':
        if (value === null || value.length === 0) {
          validationErrors.ragioneSociale = 'Inserire ragione sociale';
        } else {
          validationErrors.ragioneSociale = '';
        }
        break;
      case 'emailGestore':
        if (value === null || value.length === 0) {
          validationErrors.emailGestore =
            'Inserire indirizzo email del titolare';
        } else {
          if (validator.isEmail(value)) {
            validationErrors.emailGestore = '';
          } else {
            validationErrors.emailGestore =
              "L'indirizzo email inserito non è valido";
          }
        }
        break;
      default:
        break;
    }
    this.setState({
      validationErrors,
    });
  };

  handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    const fieldValue = type === 'checkbox' ? checked : value;

    this.setState((prevState) => ({
      record: {
        ...prevState.record,
        esercizio: {
          ...prevState.record.esercizio,
          [name]: fieldValue,
        },
      },
      validationErrors: {
        ...prevState.validationErrors,
        [name]: '', // Resetta l'errore per il campo modificato
      },
      saveButtonEnabled: true,
    }));
  };

  handleChangeAbbonamento = (value, fielName) => {
    if (!this.state.saveButtonEnabled) {
      this.setState({
        saveButtonEnabled: true,
        edit: true,
      });
    }
    let data = this.state.record;
    data.storicoPricingDTO[fielName] = value;
    this.setState({
      record: data,
    });
  };

  onChipSave = (updatedData) => {
    this.setState({
      funzionalitaApp: updatedData,
      loading: true,
    });
    updateFunzionalitaApp(updatedData)
      .then((_response) => console.log('Salvataggio avvenuto con successo.'))
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleSaveSwitch = () => {
    this.setState({
      loading: true,
    });
    const payload = {
      idEsercizioCommerciale: this.props.esercizioId,
      stato: this.state.allControlsCompliantStatus ? 'ABILITA' : 'DISABILITA',
    };
    updateAllControlsCompliantStatus(payload)
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() =>
        this.setState({
          loading: false,
        }),
      );
  };

  handleSubmit = async (event) => {
    event.preventDefault();
    if (!this.validateForm()) {
      this.handleOpenSnackbar('Correggere i campi evidenziati', 'error');
      return;
    }

    this.setState({
      loading: true,
    });

    // Creiamo una copia di record per applicare la modifica della checkbox
    let recordToUpdate = { ...this.state.record };

    if (
      !this.state.record.esercizio.gestitoDaPayments &&
      (this.state.tipologiaPagamento === 'BIORSAF' ||
        this.props.consulenteId === null)
    ) {
      let calculatedNetto =
        Number(this.state.costoUnitario) *
        Number.parseInt(recordToUpdate.storicoPricingDTO?.moltiplicatore) *
        Number.parseInt(recordToUpdate.storicoPricingDTO?.anniValidita);

      if (calculatedNetto !== recordToUpdate.storicoPricingDTO?.imponibile) {
        this.setState({
          twoActionsAlertVisible: true,
        });
        return;
      }
    }

    updateEsercizioCommerciale(this.state.record)
      .then(() => {
        this.setState(
          {
            saveButtonEnabled: false,
          },
          () => {
            this.fetchRecord(this.state.record.esercizio.id);
            this.handleOpenSnackbar('Dati aggiornati con successo', 'success');
          },
        );
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  saveUpdates = () => {
    if (!this.validateForm()) {
      this.handleOpenSnackbar('Correggere i campi evidenziati', 'error');
      return;
    }

    this.setState({
      loading: true,
    });

    const updatedRecord = JSON.parse(JSON.stringify(this.state.record));

    if (updatedRecord.storicoPricingDTO) {
      updatedRecord.storicoPricingDTO.dataAggiornamento = null;
      updatedRecord.storicoPricingDTO.imponibile =
        Number(this.state.costoUnitario) *
        Number.parseInt(this.state.record.storicoPricingDTO.moltiplicatore) *
        Number.parseInt(this.state.record.storicoPricingDTO.anniValidita);
    }

    updateEsercizioCommerciale(updatedRecord)
      .then(() => {
        this.setState(
          {
            saveButtonEnabled: false,
            twoActionsAlertVisible: false,
          },
          () => {
            this.fetchRecord(this.state.record.esercizio.id);
            this.handleOpenSnackbar('Dati aggiornati con successo');
          },
        );
      })
      .catch((error) => {
        this.setState({ twoActionsAlertVisible: false });
        reportApiError(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  closeTwoActionsAlert = () => {
    this.setState((prevState) => ({
      record: JSON.parse(JSON.stringify(prevState.originalRecord)),
      twoActionsAlertVisible: false,
      edit: false,
      loading: false,
    }));
  };

  inviomail = () => {
    let isFormValid = this.validateForm();
    if (isFormValid) {
      this.setState({
        loading: true,
      });
      sendEmailToConfirmRegistration(this.state.record.esercizio.id)
        .then(() => {
          this.setState({
            loading: false,
          });
          alert('Email inviata');
        })
        .catch((error) => {
          this.setState({ loading: false });
          reportApiError(error);
        });
    }
  };

  updateGiorniChiusura = (nuoviGiorni) => {
    this.setState((prevState) => ({
      saveButtonEnabled: true,
      record: {
        ...prevState.record,
        giorniChiusura: nuoviGiorni,
      },
    }));
  };

  handleChangeCheckbox = (event) => {
    const { name, checked } = event.target;
    this.setState((prevState) => {
      const updatedRecord = {
        ...prevState.record,
        aggiornamentoGestioneOperativaDTO: {
          ...prevState.record.aggiornamentoGestioneOperativaDTO,
          [name]: checked,
        },
      };
      return {
        record: updatedRecord,
        saveButtonEnabled: true,
      };
    });
  };

  onSaveSwitchSettings = () => {
    this.setState({
      loading: true,
    });

    const { record } = this.state;
    const updatedRecord = {
      ...record,
      aggiornamentoGestioneOperativaDTO: {
        ...record.aggiornamentoGestioneOperativaDTO,
        multiselect: record.aggiornamentoGestioneOperativaDTO.multiselect,
        notificheAggregate:
          record.aggiornamentoGestioneOperativaDTO.notificheAggregate,
      },
    };

    updateEsercizioCommerciale(updatedRecord)
      .then(() => {
        this.setState(
          {
            saveButtonEnabled: false,
            saveCheckboxSuccess: true,
          },
          () => {
            this.fetchRecord(record.esercizio.id);
            this.handleOpenSnackbar('Dati aggiornati con successo', 'success');
          },
        );
      })
      .catch((error) => {
        reportApiError(error);
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleOpenSnackbar = (message, severity = 'success') => {
    this.setState({
      snackbar: {
        open: true,
        message,
        severity,
      },
    });
  };

  handleCloseSnackbar = () => {
    this.setState({
      snackbar: {
        open: false,
        message: '',
        severity: null,
      },
    });
  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.mainContainer}>
        <UnsavedChangesNavigationGuard
          active={this.state.gestioneOperativaHasPendingChanges}
          message={UNSAVED_CHANGES_LEAVE_MESSAGE}
        />
        <Typography variant="h4" className={classes.title}>
          Dettagli esercizio commerciale
        </Typography>
        {this.state.loading ? (
          <SpinnerComponent size={24} />
        ) : (
          <Paper className={classes.tabPaper}>
            <Tabs
              value={this.state.tabValue}
              onChange={this.handleTabChange}
              variant="fullWidth"
              indicatorColor="primary"
              textColor="primary"
              classes={{
                indicator: classes.tabsIndicator,
                root: classes.tabsRoot,
              }}
            >
              <Tab
                label="Dati esercizio commerciale"
                value={0}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              {this.state.record.aggiornamentoGestioneOperativaDTO?.id &&
                this.state.gestioneOperativaOpen === true && (
                  <Tab
                    label="Gestione operativa"
                    value={1}
                    classes={{
                      root: classes.tabRoot,
                      selected: classes.tabSelected,
                    }}
                  />
                )}
              <Tab
                label="Documenti"
                value={2}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                }}
              />
              {/* Follows the iot module chip: managing Assegnazioni only makes
                  sense where the module is on. It is a module switch, not a
                  role check — the data itself is protected by tenant. */}
              {this.state.funzionalitaApp.iot &&
                this.state.record.aggiornamentoGestioneOperativaDTO?.id && (
                  <Tab
                    label="Assegnazioni IoT"
                    value={3}
                    classes={{
                      root: classes.tabRoot,
                      selected: classes.tabSelected,
                    }}
                  />
                )}
              {/* Same module chip as the Assegnazioni tab, and the same reason:
                  the recipients of the IoT notifications only exist where the
                  module is on. Unlike that tab, this one does not need a
                  published gestione operativa: the struttura scope hangs off the
                  esercizio alone, and an esercizio without reparti is exactly the
                  one whose escalation must be checked for recipients. */}
              {this.state.funzionalitaApp.iot && (
                <Tab
                  label="Notifiche IoT"
                  value={4}
                  classes={{
                    root: classes.tabRoot,
                    selected: classes.tabSelected,
                  }}
                />
              )}
            </Tabs>
            <div hidden={this.state.tabValue !== 0}>
              {this.renderDatiEsercizio()}
            </div>
            <div hidden={this.state.tabValue !== 1}>
              {this.state.tabLoaded[1] && (
                <Grid
                  container
                  justify="center"
                  style={{ paddingTop: '26px', paddingBottom: '26px' }}
                >
                  <GestioneOperativa
                    aggiornamentoGestioneOperativaDTO={
                      this.state.record.aggiornamentoGestioneOperativaDTO
                    }
                    esercizioId={this.props.esercizioId}
                    onChangeCheckbox={this.handleChangeCheckbox}
                    onPendingChangesChange={
                      this.handleGestioneOperativaPendingChanges
                    }
                    onSaveSwitchSettings={this.onSaveSwitchSettings}
                    loadingDatiEsercizio={this.state.loading}
                    checkboxSaveSuccess={this.state.saveCheckboxSuccess}
                    /* The review queue of the orphaned Assegnazioni is signalled
                       here, where the manual gets published (BSDEVPLAT-111): it is
                       the publication that produces the voci. It follows the iot
                       module chip, like the «Assegnazioni IoT» tab. */
                    mostraCodaRevisione={Boolean(
                      this.state.funzionalitaApp.iot,
                    )}
                    codaRicaricaToken={this.state.codaRicaricaToken}
                    onCodaCambiata={this.ricaricaConteggioCodaRevisione}
                    onApriCodaRevisione={() => this.handleTabChange(null, 3)}
                  />
                </Grid>
              )}
            </div>
            <div hidden={this.state.tabValue !== 2}>
              {this.state.tabLoaded[2] && (
                <Grid
                  container
                  justify="center"
                  style={{ paddingTop: '26px', paddingBottom: '26px' }}
                >
                  <DocumentiSection esercizioId={this.props.esercizioId} />
                </Grid>
              )}
            </div>
            <div hidden={this.state.tabValue !== 3}>
              {this.state.tabLoaded[3] &&
                this.state.record.aggiornamentoGestioneOperativaDTO?.id && (
                  <Grid
                    container
                    justify="center"
                    style={{ paddingTop: '26px', paddingBottom: '26px' }}
                  >
                    <AssegnazioniIotSection
                      esercizioId={this.props.esercizioId}
                      gestioneOperativaId={
                        this.state.record.aggiornamentoGestioneOperativaDTO.id
                      }
                      onCodaRevisionata={this.ricaricaConteggioCodaRevisione}
                    />
                  </Grid>
                )}
            </div>
            <div hidden={this.state.tabValue !== 4}>
              {this.state.tabLoaded[4] && (
                <Grid
                  container
                  justify="center"
                  style={{ paddingTop: '26px', paddingBottom: '26px' }}
                >
                  {/* Optional on purpose: without a published gestione operativa
                      there are no reparti to configure, and the section says so
                      while still offering the struttura scope. */}
                  <ContattiNotificheSection
                    esercizioId={this.props.esercizioId}
                    gestioneOperativaId={
                      this.state.record.aggiornamentoGestioneOperativaDTO?.id
                    }
                  />
                </Grid>
              )}
            </div>
          </Paper>
        )}

        <TwoActionsAlertDialog
          visible={this.state.twoActionsAlertVisible}
          title="Attenzione"
          message="La variazione dei parametri di abbonamento, comporterà una variazione di prezzo per l'utente finale, che verrà avvisato di conseguenza. Si desidera proseguire? "
          onIndietroClicked={this.closeTwoActionsAlert}
          onOkClicked={this.saveUpdates}
        />
      </div>
    );
  }

  renderDatiEsercizio() {
    const { classes } = this.props;
    const disabledSubmitbutton =
      this.state.loading || !this.state.saveButtonEnabled;
    const isConsulente =
      this.props.consulenteId !== null && this.props.superconsulente === false;

    return (
      <Grid
        container
        justify="center"
        style={{ paddingTop: '26px', paddingBottom: '26px' }}
      >
        <div style={{ minHeight: '700px' }}>
          {this.state.notfoundRecord ? (
            <Typography
              variant="h6"
              style={{ paddingTop: '6px', paddingBottom: '6px' }}
            >
              Nessun record trovato
            </Typography>
          ) : (
            <Fragment>
              {this.state.record.esercizio.terminiUsoAccettati === true &&
              this.state.record.esercizio.privacyPolicyAccettata ===
                true ? null : (
                <Button
                  type="submit"
                  onClick={this.inviomail}
                  variant="contained"
                  size="medium"
                  className={classes.invioMailButton}
                >
                  Invia mail di attivazione
                </Button>
              )}
              <form autoComplete="off" onSubmit={this.handleSubmit}>
                <FormDettagli
                  record={this.state.record}
                  handleChange={this.handleChange}
                  validationErrors={this.state.validationErrors}
                  gestioneOperativaOpen={this.state.gestioneOperativaOpen}
                />
                {!this.state.record.esercizio.gestitoDaPayments &&
                  this.state.record.storicoPricingDTO &&
                  (this.props.consulenteId === null ||
                    (this.props.consulenteId !== null &&
                      this.state.tipologiaPagamento === 'BIORSAF')) && (
                    <FormPagamento
                      costoUnitario={this.state.costoUnitario}
                      abbonamentoData={this.state.record.storicoPricingDTO}
                      handleChangeAbbonamento={this.handleChangeAbbonamento}
                    />
                  )}
                {!isConsulente && (
                  <ChipSection
                    funzionalitaApp={this.state.funzionalitaApp}
                    onChipSave={this.onChipSave}
                  />
                )}
                {/* Next to the `iot` module chip on purpose, and outside the
                    role guard on purpose (BSDEVPLAT-119): the chip shows the IoT
                    section in the app, the switch flips the ADR-0014 gate for
                    this esercizio. Whether the flip is allowed is the server's
                    answer, shown as esito, not a check on who is looking. */}
                <InterruttoreGateIotSection
                  esercizioId={this.state.record.esercizio.id}
                />
                <Paper className={classes.sectionContainer}>
                  <Typography
                    variant="subtitle1"
                    gutterBottom
                    className={classes.sectionTitle}
                  >
                    Impostazioni avanzate
                  </Typography>
                  <div className={classes.switchContainer}>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={
                            this.state.allControlsCompliantStatus || false
                          }
                          onChange={(e) => {
                            this.setState({
                              allControlsCompliantStatus: e.target.checked,
                            });
                          }}
                          color="primary"
                          title={
                            this.state.allControlsCompliantStatus
                              ? 'Disabilita'
                              : 'Abilita'
                          }
                        />
                      }
                      label="Abilita la funzione di registrazione dei controlli residui a conformi"
                    />
                    <Button
                      onClick={this.handleSaveSwitch}
                      variant="contained"
                      color="primary"
                      size="small"
                      disabled={this.state.loading}
                    >
                      Salva impostazioni
                    </Button>
                  </div>
                </Paper>
                {!this.state.record.esercizio.gestitoDaPayments && (
                  <StoricoAbbonamentiEsercizio
                    edit={this.state.edit}
                    consulenteId={this.props.consulenteId}
                    tipologiaPagamento={this.state.tipologiaPagamento}
                    abbonamenti={this.state.abbonamenti}
                    theme={this.props.theme}
                    esercizioId={this.state.record.esercizio.id}
                  />
                )}
                <GiorniChiusuraEsercizio
                  esercizioId={this.state.record.esercizio.id}
                  giorniChiusura={this.state.record.giorniChiusura}
                  updateGiorniChiusura={this.updateGiorniChiusura}
                />
                <Grid container justify="center" style={{ paddingTop: '10px' }}>
                  <CustomSnackbar
                    open={this.state.snackbar.open}
                    onClose={this.handleCloseSnackbar}
                    message={this.state.snackbar.message}
                    severity={this.state.snackbar.severity}
                  />
                  <Grid item xs={12} style={{ textAlign: 'right' }}>
                    <IndietroButton isDisabled={this.state.loading} />
                    <Button
                      type="submit"
                      onClick={this.handleSubmit}
                      variant="contained"
                      size="medium"
                      disabled={disabledSubmitbutton}
                      style={{
                        color: disabledSubmitbutton
                          ? this.props.theme.palette.text.disabled
                          : this.props.theme.palette.text.main,
                        margin: '10px',
                        backgroundColor: disabledSubmitbutton
                          ? this.props.theme.palette.disabled.main
                          : this.props.theme.palette.primary.main,
                      }}
                    >
                      Salva modifiche
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </Fragment>
          )}
        </div>
      </Grid>
    );
  }
}

DettaglioEsercizioCommerciale.propTypes = {
  classes: PropTypes.object.isRequired,
  consulenteId: PropTypes.number,
  esercizioId: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  superconsulente: PropTypes.bool.isRequired,
  theme: PropTypes.object.isRequired,
};

export default withRouter(withStyles(styles)(DettaglioEsercizioCommerciale));
